module.exports = __webpack_public_path__ + "static/scale-model-of-pedal-wagon-covington-in-cincinnati-ohio-fc86563f9ab312cdf7e01245687714e8.png";